export default "__VITE_ASSET__DpYoslyd__"